// A component that allows a date range to be selected.
// @flow
import React, { PureComponent } from 'react';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';
import FilterBarButton from './FilterBarButton';
import * as DateUtils from '../../lib/dateUtils';
import { LeftButton, RightButton } from './DatePickerCommonButtons';

type OnChangeObject = { startDate: moment$Moment, endDate: moment$Moment };

export type DateRangeSelectionProps = {
    startDate: moment$Moment,
    endDate: moment$Moment,
    onChange: OnChangeObject => void
};

type State = {
    focusedInput: string | null
};

export default class DateRangeSelection extends PureComponent<
    DateRangeSelectionProps,
    State
> {
    // This is required by the DateRangePicker API.
    state: State = {
        focusedInput: null
    };

    setDateRangeFromToday = (days: number) => {
        const endDate = moment();
        const startDate = moment().subtract(days, 'd');
        this.props.onChange({
            endDate,
            startDate
        });
    };

    render() {
        return (
            <div className="date-range-container">
                <DateRangePicker
                    noBorder
                    minimumNights={0}
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}
                    isOutsideRange={() => false}
                    startDateId="startDate"
                    endDateId="endDate"
                    displayFormat={DateUtils.CALENDAR_FORMAT}
                    onDatesChange={(props: OnChangeObject) => {
                        if (!props.startDate) {
                            return;
                        }
                        if (!props.endDate) {
                            props.endDate = props.startDate.clone();
                        }
                        this.props.onChange(props);
                    }}
                    focusedInput={this.state.focusedInput}
                    onFocusChange={(focusedInput: string) =>
                        this.setState({ focusedInput })
                    }
                    initialVisibleMonth={() =>
                        this.props[this.state.focusedInput]
                    }
                    navPrev={<LeftButton className="date-picker-previous" />}
                    navNext={<RightButton className="date-picker-next" />}
                />
                <FilterBarButton
                    onClick={this.setDateRangeFromToday.bind(null, 0)}
                >
                    Today
                </FilterBarButton>
                <FilterBarButton
                    onClick={this.setDateRangeFromToday.bind(null, 10)}
                >
                    Last 10 Days
                </FilterBarButton>
                <FilterBarButton
                    onClick={this.setDateRangeFromToday.bind(null, 30)}
                >
                    Last 30 Days
                </FilterBarButton>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/analytics/DateRangeSelection.jsx